export const hikvisionDataUploadCorrectValues = {
    dataUploadInterval: '15',
    dataUploadGranularity: null,
};
